import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="layout">
      <Header toggleSidebar={toggleSidebar} />
      <div className={`layout-content ${sidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Mobile Overlay */}
        <div 
          className={`sidebar-overlay ${sidebarCollapsed ? 'show' : ''}`} 
          onClick={toggleSidebar}
        />
        <Sidebar collapsed={sidebarCollapsed} />
        <main className="main-content">
          <div className="main-container">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
